module.exports = __webpack_public_path__ + "img/pinefall.82e05818.png";